module.exports = __webpack_public_path__ + "img/icon_close_nb.f0c4fbf0.svg";